<template>
  <!-- BEGIN pos-sidebar -->
  <div class="pos-sidebar" id="pos-sidebar">
    <div class="pos-sidebar-header">
      <div class="back-btn">
        <button
          type="button"
          v-on:click="$emit('pos-mobile-sidebar-toggled')"
          class="btn"
        >
          <svg
            viewBox="0 0 16 16"
            class="bi bi-chevron-left"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
            />
          </svg>
        </button>
      </div>
      <div class="icon">
        <img src="@/assets/icon-table.svg" style="max-width: 40px;" />
      </div>
      <div class="title">
        {{ $t('restaurantSale.table') }}
        {{ tableSelected ? tableSelected.table_no : '' }}
      </div>
      <div class="order">
        {{ $t('restaurantSale.order') }}:
        <b>#{{ dataSend.order_no }}</b>
      </div>
    </div>
    <div class="pos-sidebar-nav">
      <ul class="nav nav-tabs nav-fill">
        <li class="nav-item">
          <a
            class="nav-link active"
            href="#"
            data-toggle="tab"
            data-target="#newOrderTab"
            >{{ $t('restaurantSale.newOrder') }} ({{
              dataSend.products.length
            }})</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            style="padding: 4px 0 !important;"
            href="#"
            data-toggle="tab"
            data-target="#orderHistoryTab"
          >
            <div class="btn-group btn-group-justified">
              <a
                v-for="language in languages"
                :key="language.code"
                @click="$emit('change-language', language)"
                class="btn btn-default"
                :class="{ 'btn-info': language.code == locale }"
              >
                <span
                  :class="`flag-icon flag-icon-${language.icon} ts-text-lg`"
                  :title="language.icon"
                ></span>
                {{ language.caption }}
              </a>
            </div></a
          >
        </li>
      </ul>
    </div>
    <div
      class="pos-sidebar-body tab-content"
      data-scrollbar="true"
      data-height="100%"
    >
      <div class="tab-pane fade h-100 show active" id="newOrderTab">
        <!-- ADD v-if TO ENSURE ELEMENT EXISTS BEFORE SCROLLING -->
        <div
          class="pos-table"
          ref="add_to_card"
          v-if="dataSend.products && dataSend.products.length > 0"
        >
          <OrderItem
            v-for="(order, index) in orderBy(dataSend.products)"
            :key="index"
            :order="order"
            :index="index"
            :errors="errors"
            @remove-item="$emit('remove-item', $event)"
            @set-promotion-item-free-item="
              $emit('set-promotion-item-free-item', $event)
            "
            @set-promotion-discount-ordered="
              $emit('set-promotion-discount-ordered', $event)
            "
          />
        </div>
      </div>
      <div class="tab-pane fade h-100" id="orderHistoryTab">
        <div
          class="h-100 d-flex align-items-center justify-content-center text-center p-20"
        >
          <div>
            <div class="mb-3 mt-n5">
              <svg
                width="6em"
                height="6em"
                viewBox="0 0 16 16"
                class="text-gray-300"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M14 5H2v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5zM1 4v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4H1z"
                />
                <path
                  d="M8 1.5A2.5 2.5 0 0 0 5.5 4h-1a3.5 3.5 0 1 1 7 0h-1A2.5 2.5 0 0 0 8 1.5z"
                />
              </svg>
            </div>
            <h4>{{ $t('restaurantSale.noOrderHistoryFound') }}</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="pos-sidebar-footer ts-whitespace-no-wrap">
      <div class="subtotal">
        <div class="text">{{ $t('restaurantSale.subtotal') }}</div>
        <div class="price">{{ defaultCurrency }} {{ dataSend.sub_total }}</div>
      </div>
      <div class="taxes">
        <div class="text">VAT {{ vatRate ? '(' + vatRate + '%)' : '' }}</div>
        <div class="price">{{ defaultCurrency }} {{ dataSend.vat_amount }}</div>
      </div>
      <hr class="opacity-1" />
      <div class="total">
        <div class="text">{{ $t('restaurantSale.grandTotal') }}</div>
        <div class="price">
          {{ defaultCurrency }} {{ dataSend.grand_total }}
        </div>
      </div>
      <div class="btn-row ts-space-x-2">
        <ts-button @click.prevent="$emit('check-bill')"
          ><i class="fa fa-arrow-left fa-fw fa-lg"></i>
          {{ $t('restaurantSale.back') }}</ts-button
        >
        <ts-button
          color="success"
          @click.prevent="$emit('submit-order')"
          :waiting="waiting"
          :disabled="waiting || (tableSelected.table_id ? false : true)"
          ><i class="fa fa-shopping-cart fa-fw fa-lg" v-if="!waiting"></i>
          {{ $t('restaurantSale.submitOrder') }}</ts-button
        >
      </div>
    </div>
  </div>
  <!-- END pos-sidebar -->
</template>

<script>
import { orderBy } from 'lodash'
import OrderItem from './OrderItem.vue'

export default {
  name: 'PosSidebar',
  components: {
    OrderItem
  },
  props: {
    tableSelected: Object,
    dataSend: Object,
    locale: String,
    vatRate: Number,
    defaultCurrency: String,
    waiting: Boolean,
    errors: Object
  },
  data() {
    return {
      languages: [
        { code: 'kh', icon: 'kh', caption: 'ខ្មែរ' },
        { code: 'en', icon: 'us', caption: 'English' }
      ]
    }
  },
  methods: {
    orderBy(items) {
      return orderBy(items, ['display_order'])
    }
  }
}
</script>

<style scoped>
.pos-customer .pos-sidebar .pos-sidebar-header {
  padding: 16px 12px !important;
  background: #495057;
}
.pos-customer .pos-sidebar .pos-sidebar-header .order {
  background: #00acac;
  color: #ffffff;
  padding: 2px 6px;
}
hr {
  margin: 0.9375rem 0;
  color: #adb5bd;
  border: 0;
  opacity: 0.4;
}
.pos-customer .pos-sidebar .pos-sidebar-body .pos-table {
  padding: 0 10px;
}
.pos-customer .pos-sidebar .pos-sidebar-body .pos-table .pos-table-row {
  padding: 10px 0;
}
.pos-customer .pos-sidebar .pos-sidebar-footer {
  background: #495057 !important;
  color: #f8f9fa;
  position: relative;
  padding: 10px 25px;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  -webkit-box-shadow: 0 -1px rgba(52, 58, 64, 0.1);
  box-shadow: 0 -1px rgba(52, 58, 64, 0.1);
}
.pos-customer .pos-sidebar .pos-sidebar-footer .btn-row {
  padding: 10px;
  margin: 0 -25px -10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.pos-customer .pos-sidebar .pos-sidebar-footer .btn-row .btn {
  border-radius: 10px !important;
}
</style>
